import { Button, Icon, Flex, Box, ButtonProps, Text } from '@chakra-ui/react';
import { CSSProperties } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

export interface SubSidebarMenuButtonProps extends ButtonProps {
  icon: React.ElementType;
  label: string;
  link: string;
  iconStyles?: CSSProperties;
  bg?: string;
  snapshot?: number;
  variant?: string;
  criteria?: string[];
  isActive?: boolean;
}

export function SubSidebarMenuButton(props: SubSidebarMenuButtonProps) {
  const { icon, label, iconStyles, bg, snapshot, variant = 'tertiary', ...buttonProps } = props;

  const isActiveLink = props.isActive ?? false;

  return (
    <Button
      variant={variant}
      justifyContent="start"
      py={1.5}
      px={2}
      bg={isActiveLink ? 'bg.emphasis' : undefined}
      w="full"
      as={ReactRouterLink}
      to={props.link}
      {...buttonProps}
    >
      <Flex alignItems="center" alignSelf="stretch" w="full" justifyContent="space-between">
        <Flex gap={2.5} alignItems="center" alignSelf="stretch" minW={0} flex={1}>
          <Icon
            as={icon}
            boxSize={4}
            color={variant === 'link' ? 'accent' : 'fg.emphasis'}
            style={iconStyles}
          />
          <Text
            textStyle="sm"
            color={variant === 'link' ? 'accent' : 'fg.default'}
            fontWeight={isActiveLink ? 'semibold' : 'normal'}
            noOfLines={1}
          >
            {label}
          </Text>
        </Flex>
        {snapshot !== undefined ? (
          <Box py={0.5} px={2} borderRadius="full" background="bg.surface">
            <Text textStyle="xs" textAlign="center">
              {snapshot}
            </Text>
          </Box>
        ) : null}
      </Flex>
    </Button>
  );
}
